import { hasEmptyValue } from 'Lib/Any';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { actions } from '../../../Data/ReduxViewModels/ServiceSetup';
import { Spinner } from '../../Core';
import Connection from './Connection';

const ServiceSetupPage = () => {
  const initialising = useSelector((state) => state.serviceSetup.status.initialising);
  const retrievingData = useSelector(
    (state) => state.serviceSetup.status.retrievingData && hasEmptyValue(state.serviceSetup.connection)
  );

  const showSpinner = initialising || retrievingData;
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(actions.getDatabaseConfigured());
  }, [dispatch]);

  return <main>{showSpinner ? <Spinner large /> : <Connection />}</main>;
};

export default ServiceSetupPage;
